import { useEffect, useState } from "react";

import {
  getData,
  updateUserRole,
  deleteUser,
} from "../../../services/user.service";
import Header from "../header";
import styles from "./styles.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import ConfirmationDeleteUserModal from "./delete-modal";
import RegisterUser from "./register-user";
import Button from "../../../components/button";

const columnNames = {
  ID: "id",
  Usuario: "username",
  Email: "email",
  Rol: "role",
};

const UserManagement = () => {
  const [userData, setUserData] = useState([]);
  const [openNewUser, setOpenNewUser] = useState(false);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [userIdToDelete, setUserIdToDelete] = useState(null);

  const handleDropdownChange = (e, key, it) => {
    const newRole = e.target.value;
    updateUserRole(key, newRole)
      .then((response) => {
        const updatedUserData = userData.map((user) => {
          if (user.id === key) {
            user.role = newRole;
          }
          return user;
        });
        setUserData(updatedUserData);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const renderCellWithDropdown = (key, it) => {
    const value = userData.find((user) => user.id === key).role;
    return (
      <select
        className={styles.dropdown}
        onChange={(e) => handleDropdownChange(e, key, it)}
        value={value}
      >
        <option value="admin">Admin</option>
        <option value="user">User</option>
        <option value="operator">Operator</option>
      </select>
    );
  };

  const handleAddNewUser = () => {
    setOpenNewUser(true);
  };

  const closeRegisterForm = () => {
    setOpenNewUser(false);
  };

  const handleDeleteUser = (id) => {
    deleteUser(id)
      .then((response) => {
        const updatedUserData = userData.filter((user) => user.id !== id);
        setUserData(updatedUserData);
        handleCloseConfirmationModal();
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const handleOpenConfirmationModal = (userID) => {
    setOpenConfirmationModal(true);
    setUserIdToDelete(userID);
  };

  const handleCloseConfirmationModal = () => {
    setOpenConfirmationModal(false);
  };

  useEffect(() => {
    getData("users")
      .then((response) => {
        setUserData(response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  return (
    <div className={styles.container}>
      <Header handleAddNewUser={handleAddNewUser} />
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr className={styles.tableHeader}>
              {Object.keys(columnNames).map((key) => (
                <th key={key} className={styles.tableHeaderCell}>
                  {key}
                </th>
              ))}
              <th className={styles.tableHeaderCell}>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {userData.map((row, index) => (
              <tr
                key={row.id}
                className={`${styles.tableRow} ${index % 2 === 0 ? "" : styles.tableRowAlt}`}
              >
                {Object.keys(columnNames).map((key) => (
                  <td key={key} className={styles.tableCell}>
                    {key === "Rol"
                      ? renderCellWithDropdown(row.id, key)
                      : row[columnNames[key]]}
                  </td>
                ))}
                <td className={styles.actionCell}>
                  <Button
                    variant="ghost"
                    size="small"
                    onClick={() => handleOpenConfirmationModal(row.id)}
                    title="Eliminar usuario"
                  >
                    <FontAwesomeIcon icon={faTrash} />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {openNewUser && <RegisterUser handleClose={closeRegisterForm} />}
      {openConfirmationModal && (
        <ConfirmationDeleteUserModal
          userName={
            userData.find((user) => user.id === userIdToDelete).username
          }
          handleClose={handleCloseConfirmationModal}
          handleDelete={() => handleDeleteUser(userIdToDelete)}
        />
      )}
    </div>
  );
};

export default UserManagement;
